import multilanguage from 'i18n/translations.json';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const normalizeLang = (lang: string) => lang.replace('-', '_');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: Object.fromEntries(
      Object.entries(multilanguage).map(([lang, translations]) => [
        normalizeLang(lang),
        { translation: translations as { [key: string]: string } }
      ])
    ),
    fallbackLng: {
      pt: ['pt_BR'],
      es: ['es'],
      en: ['en'],
      default: ['en']
    },
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'htmlTag', 'localStorage', 'cookie'],
      caches: ['localStorage']
    }
  });

export default i18n;